import React, { useEffect, useState } from "react";
import { Popover, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";

import API_BASE_URL, { Providers } from "../../services/Config";
import axios from "axios";
import { useGlobalContext } from "../../services/GlobalContext";
import { useDispatch } from "react-redux";
import { fetchUser } from "../../store/user/userSlice";

const initialAccessState = [
    {
        name: "Registo de Consumos",
        isChecked: false,
        state: false,
        alias: "occurrence_registration",
    },
    {
        name: "Gestão Financeira",
        isChecked: false,
        state: false,
        alias: "financial_management",
    },
    {
        name: "Gestão Clinica",
        isChecked: false,
        state: false,
        alias: "clinical_management",
    },
];

const AddComponent = ({
    setIsComplete,
    setMembers,
    members,
    submit,
    item,
    setSubmit,
    update,
    setUpdate,
    setEditStatus,
    editStatus,
}) => {
    const dispatch = useDispatch();
    const [openPopUpId1, setOpenPopUpId1] = useState(null);
    const [anchorElValue, setAnchorElValue] = useState(null);

    const [openPopUpId2, setOpenPopUpId2] = useState(null);
    const [anchorElValue2, setAnchorElValue2] = useState(null);
    const [Id, setId] = useState();
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [entity, setEntity] = useState([]);
    const [access, setAccess] = useState(initialAccessState);
    const [isChange, setIsChange] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emailErrorSubmit, setEmailErrorSubmit] = useState(false);
    const [entityList, setEntityList] = useState([]);
    // const [operatorId, setOperatorId] = useState("");
    const [isAllSelected, setIsAllSelected] = useState(false);

    const { setloading } = useGlobalContext();

    const token = localStorage.getItem("authToken");
    const userData = JSON.parse(localStorage.getItem("userData"));
    const provider_id = userData["provider_id"];

    const handlPopUpValue = (e, id) => {
        setAnchorElValue(e.currentTarget);
        setOpenPopUpId1(id);
    };

    const handlPopUpValueAcess = (e, id) => {
        setAnchorElValue2(e.currentTarget);
        setOpenPopUpId2(id);
    };
    const handlePopUpCloseValue = () => {
        setAnchorElValue(null);
        setOpenPopUpId1(null);
    };
    const handlePopUpCloseValueAcess = () => {
        setAnchorElValue2(null);
        setOpenPopUpId2(null);
    };

    useEffect(() => {
        console.log("entity", entity);
    }, [entity]);

    const fetchList = async () => {
        setloading(true);
        await axios
            .get(
                `${API_BASE_URL()}/v3/${Providers()}/distribution-points?order_by=-updated`,
                {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                setEntityList(res.data?.elements);
                if (res.data?.elements.length === 0)
                    setEntity([]);
                setloading(false);
            })
            .catch((e) => {
                console.log(e);
                setloading(false);
            });
    };

    const fetchMembers = async () => {
        setloading(true);
        await axios
            .get(
                `${API_BASE_URL()}/v3/${Providers()}/provider-operators?order_by=-created`,
                {
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                const sortedData = res.data.elements
                    .map((item) => ({
                        ...item,
                        status: 1,
                    }))
                    .sort((a, b) => {
                        if (a.status !== b.status) {
                            return a.status - b.status;
                        }
                        if (
                            (a.status === 1 || a.status === 2) &&
                            (b.status === 1 || b.status === 2)
                        ) {
                            const statePriority = (state) =>
                                state === "canceled" ? -1 : 0;
                            return (
                                statePriority(a.state) - statePriority(b.state)
                            );
                        }

                        return 0;
                    });
                setMembers(sortedData);
                setloading(false);
            })
            .catch((e) => {
                console.log(e);
                setloading(false);
            });
    };

    useEffect(() => {
        if (item?.tags) {
            const newAccess = access.map((item) => ({
                ...item,
                isChecked: false, // Reset all to false initially
                state: false,
            }));

            item.tags.forEach((tag) => {
                if (tag.includes("edit")) {
                    const alias = tag.split(".")[5];
                    const accessIndex = newAccess.findIndex(
                        (item) => item.alias === alias
                    );
                    if (accessIndex !== -1) {
                        newAccess[accessIndex].isChecked = true;
                        newAccess[accessIndex].state = true;
                    }
                } else if (tag.includes("view")) {
                    const alias = tag.split(".")[5];
                    const accessIndex = newAccess.findIndex(
                        (item) => item.alias === alias
                    );
                    if (accessIndex !== -1 && !newAccess[accessIndex].state) {
                        newAccess[accessIndex].isChecked = true;
                        newAccess[accessIndex].state = false;
                    }
                }
            });
            setAccess(newAccess);
        }
    }, [item]);

    useEffect(() => {
        if (editStatus) {
            const items = item?.distribution_points?.map((items) => {
                return items?.distributionpoint?.name;
            });
            setEntity(items);
            setEditStatus(false);
        }
    }, [editStatus]);

    useEffect(() => {
        fetchList();
    }, []);

    useEffect(() => {
        if (name && email && (entityList?.length === 0 || entity?.length > 0)) {
            if (members.length > 0) {
                if (item.status === 0) {
                    if (!emailError) {
                        setIsComplete(true);
                    } else {
                        setIsComplete(false);
                    }
                }
            } else {
                if (!emailError) {
                    setIsComplete(true);
                } else {
                    setIsComplete(false);
                }
            }
        } else {
            setIsComplete(false);
        }
    }, [email, entity, access]);

    const onClose = () => {
        if (
            name !== "" &&
            email !== "" &&
            entity?.length > 0 &&
            access?.length > 0
        ) {
            const newMembers = members.map((member) =>
                member.id === Id ? { ...member, status: 1 } : member
            );
            // Update the members state
            const sortedMembers = newMembers.sort(
                (a, b) => a.status - b.status
            );
            setMembers(sortedMembers);
        } else {
            const newMembers = members?.filter(
                (member) => member.id !== item.id
            );
            const sortedMembers = newMembers.sort(
                (a, b) => a.status - b.status
            );
            setMembers(sortedMembers);
        }
        setEmail("");
        setName("");
        setEntity([]);
        setAccess(initialAccessState);
    };

    const onUpdate = async () => {
        setIsChange(false);

        setloading(true);
        // const points_list = entityList
        //     .filter(member => entity.includes(member.name))
        //     .map(member => ({ distributionpoint_id: member.id }));
        // const res = await axios.post(`${API_BASE_URL()}/v3/${Providers()}/provider-operators/${item.id}/update-distribution-points`, {
        //     distribution_points: points_list
        // }, {
        //     headers: {
        //         'Authorization': 'Bearer ' + token,
        //         'Content-Type': 'application/json',
        //     }
        // });

        const updateTags = async () => {
            let tags = [];
            access.forEach((data) => {
                if (data.isChecked === true) {
                    if (data.state === true) {
                        tags.push(
                            `io.habit.operations.grants.view.${data.alias}.user`
                        );
                        tags.push(
                            `io.habit.operations.grants.edit.${data.alias}.user`
                        );
                    } else {
                        tags.push(
                            `io.habit.operations.grants.view.${data.alias}.user`
                        );
                    }
                }
            });

            try {
                const res = await axios.post(
                    `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${
                        item.id
                    }/update`,
                    {
                        tags,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                            "Content-Type": "application/json",
                        },
                    }
                );
            } catch (e) {
                console.log(e);
            }
        };

        updateTags();

        setloading(false);
        await fetchMembers();
        dispatch(fetchUser());
        setEmail("");
        setName("");
        setEntity([]);
        setAccess(initialAccessState);
    };

    const onBack = () => {
        setIsChange(false);
        const updatedMembers = members.map((member) => {
            if (member.id === item.id) {
                return {
                    ...member,
                    status: 1,
                };
            }
            return member;
        });
        const sortedMembers = updatedMembers.sort(
            (a, b) => a.status - b.status
        );

        console.log("sortedMembers", sortedMembers);
        setMembers(sortedMembers);
        setEmail("");
        setName("");
        setEntity([]);
        setAccess(initialAccessState);
    };

    useEffect(() => {
        const submitData = async () => {
            if (emailError) {
                setEmailErrorSubmit(true);
                setSubmit(false);
                return;
            }
            setloading(true);

            try {
                const res = await axios.post(
                    `${API_BASE_URL()}/v3/${Providers()}/provideroperator-invite`,
                    {
                        name,
                        email,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const operatorId = res?.data?.provideroperator?.id;
                const points_list = entityList
                    .filter((member) => entity.includes(member.name))
                    .map((member) => ({ distributionpoint_id: member.id }));
                await axios.post(
                    `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${operatorId}/update-distribution-points`,
                    {
                        distribution_points: points_list,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const updateTags = async () => {
                    let tags = [];
                    access.forEach((data) => {
                        if (data.isChecked === true) {
                            if (data.state === true) {
                                tags.push(
                                    `io.habit.operations.grants.view.${data.alias}.user`
                                );
                                tags.push(
                                    `io.habit.operations.grants.edit.${data.alias}.user`
                                );
                            } else {
                                tags.push(
                                    `io.habit.operations.grants.view.${data.alias}.user`
                                );
                            }
                        }
                    });

                    try {
                        const res = await axios.post(
                            `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${operatorId}/update`,
                            {
                                tags,
                            },
                            {
                                headers: {
                                    Authorization: "Bearer " + token,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                    } catch (e) {
                        console.log(e);
                    }
                };

                updateTags();

                setloading(false);
                setIsComplete(false);
                setSubmit(false);
                await fetchMembers();
                setEmail("");
                setName("");
                setEntity([]);
                setAccess(initialAccessState);
                dispatch(fetchUser());
            } catch (e) {
                setloading(false);
                setIsComplete(false);
                setSubmit(false);
                setEmail("");
                setName("");
                setEntity([]);
                setAccess(initialAccessState);
                toast.error(e.response.data.text);
            }
        };
        if (submit) {
            submitData();
        }
    }, [submit]);

    useEffect(() => {
        if (update) {
            if (email !== "" && entity?.length > 0 && access?.length > 0) {
                const updatedMembers = members.map((member) => {
                    if (member.id === Id) {
                        return {
                            ...member,
                            email: email,
                            entity: entity,
                            access: access,
                            status: 1,
                        };
                    }
                    return member;
                });
                const sortedMembers = updatedMembers.sort(
                    (a, b) => a.status - b.status
                );
                setMembers(sortedMembers);
                setIsComplete(false);
                setUpdate(false);
                setEmail("");
                setName("");
                setEntity([]);
                setAccess(initialAccessState);
            }
        }
    }, [update]);
    //this is only for entity
    const handleEntity = async (id, name) => {
        setIsChange(true);
        if (item.status === 0) {
            if (id === 1) {
                if (entity?.length === entityList?.length) {
                    setEntity([]);
                } else {
                    setEntity(entityList?.map((item) => item.name));
                }
            } else {
                if (entity?.length > 0) {
                    if (entity.includes(name)) {
                        setEntity(entity.filter((item) => item !== name));
                    } else {
                        setEntity([...entity, name]);
                    }
                } else {
                    setEntity([name]);
                }
            }
        } else {
            try {
                if (id === 1) {
                    if (entity?.length === entityList?.length) {
                        const points_list = entityList.map(
                            (member) => member.id
                        );

                        await axios.post(
                            `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${
                                item.id
                            }/remove-distribution-points`,
                            {
                                distribution_points: points_list,
                            },
                            {
                                headers: {
                                    Authorization: "Bearer " + token,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                        setEntity([]);
                    } else {
                        const points_list = entityList.map((member) => ({
                            distributionpoint_id: member.id,
                        }));
                        await axios.post(
                            `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${
                                item.id
                            }/update-distribution-points`,
                            {
                                distribution_points: points_list,
                            },
                            {
                                headers: {
                                    Authorization: "Bearer " + token,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                        setEntity(entityList?.map((item) => item.name));
                    }
                } else {
                    if (entity?.length > 0) {
                        if (entity.includes(name)) {
                            await axios.post(
                                `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${
                                    item.id
                                }/remove-distribution-points`,
                                {
                                    distribution_points: [id],
                                },
                                {
                                    headers: {
                                        Authorization: "Bearer " + token,
                                        "Content-Type": "application/json",
                                    },
                                }
                            );
                            setEntity(entity.filter((item) => item !== name));
                        } else {
                            await axios.post(
                                `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${
                                    item.id
                                }/update-distribution-points`,
                                {
                                    distribution_points: [
                                        {
                                            distributionpoint_id: id,
                                        },
                                    ],
                                },
                                {
                                    headers: {
                                        Authorization: "Bearer " + token,
                                        "Content-Type": "application/json",
                                    },
                                }
                            );
                            setEntity([...entity, name]);
                        }
                    } else {
                        await axios.post(
                            `${API_BASE_URL()}/v3/${Providers()}/provider-operators/${
                                item.id
                            }/update-distribution-points`,
                            {
                                distribution_points: [
                                    {
                                        distributionpoint_id: id,
                                    },
                                ],
                            },
                            {
                                headers: {
                                    Authorization: "Bearer " + token,
                                    "Content-Type": "application/json",
                                },
                            }
                        );
                        setEntity([name]);
                    }
                }
            } catch (e) {
                console.log(e);
            }
        }
    };
    const handleAccess = (alias, state) => {
        setAccess(
            access.map((item) =>
                item.alias === alias
                    ? { ...item, isChecked: !item.isChecked }
                    : item
            )
        );
    };

    const setStatus = (alias, state) => {
        setAccess(
            access.map((item) =>
                item.alias === alias ? { ...item, state: state } : item
            )
        );
    };

    const handleSelectAll = () => {
        setIsAllSelected(!isAllSelected);
        setAccess(
            access.map((item) => ({ ...item, isChecked: !isAllSelected }))
        );
    };

    useEffect(() => {
        if (access.every((item) => item.isChecked === true)) {
            setIsAllSelected(true);
        } else {
            setIsAllSelected(false);
        }
    }, [access]);

    const handleEmail = (e) => {
        setIsChange(true);
        setEmail(e.target.value);
        setEmailErrorSubmit(false);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(e.target.value)) {
            setEmailError(true);
        } else {
            setEmailError(false);
        }
    };

    const handleName = (e) => {
        setName(e.target.value);
    };
    return (
        <div className="bg-[#FEF3D1] py-[23px] rounded-[11px] grid grid-cols-10 gap-[15px] relative pl-[23px] pr-[50px]">
            {item.status !== 4 && (
                <div
                    className={`flex flex-col gap-[5px] ${
                        item.status === 0 ? "col-span-2" : "col-span-2"
                    }`}
                >
                    <p className="font-14-700 text-[#697DA4] text-left">Nome</p>
                    {item.status === 0 ? (
                        <input
                            className={`bg-white rounded-[100px] px-[20px] py-[6px] text-[#29215B] font-16-500 border-none`}
                            onChange={(e) => handleName(e)}
                            placeholder="Inserir..."
                            value={name}
                        />
                    ) : (
                        <input
                            className={`bg-white rounded-[100px] px-[20px] py-[6px] text-[#29215B] font-16-500 border-none`}
                            value={item.name}
                            disabled
                        />
                    )}
                </div>
            )}

            {item.status === 0 && (
                <div className="flex flex-col gap-[5px] col-span-3">
                    <p className="font-14-700 text-[#697DA4] text-left">
                        Email
                    </p>
                    <input
                        className={`bg-white rounded-[100px] px-[20px] py-[6px] text-[#29215B] font-16-500 ${
                            emailError
                                ? "border-red-500 border-[1px]"
                                : "border-none"
                        }`}
                        onChange={(e) => handleEmail(e)}
                        placeholder="Inserir..."
                        value={email}
                    />
                    {emailError && (
                        <p className="px-4 text-red-500 font-13-500">
                            e-mail inválido
                        </p>
                    )}
                </div>
            )}
            {item.status !== 0 && (
                <div className="flex flex-col gap-[5px] col-span-3">
                    <p className="font-14-700 text-[#697DA4] text-left">
                        Email
                    </p>
                    <input
                        className={`bg-white rounded-[100px] px-[20px] py-[6px] text-[#29215B] font-16-500 border-none`}
                        value={item.email}
                        disabled
                    />
                </div>
            )}
            {entityList?.length > 0 ? (
                <div className="flex flex-col gap-[5px] col-span-3">
                    <p className="font-14-700 text-[#697DA4] text-left">
                        Entidades
                    </p>
                    <button
                        className="bg-white w-full h-[35px] rounded-[100px] flex flex-row justify-between  self-center place-content-center px-[14px]"
                        onClick={(e) => handlPopUpValue(e, 1)}
                    >
                        <span className="font-16-500 text-[#29215B] self-center">
                            {entity?.length > 0 ? (
                                entity[0] +
                                (entity.length > 1
                                    ? "... +" + (entity.length - 1)
                                    : "")
                            ) : (
                                <span className="font-16-500 text-[#95AFC9] self-center">
                                    Selecionar...
                                </span>
                            )}
                        </span>
                        <KeyboardArrowDownIcon
                            style={{ fontSize: "18px" }}
                            className="self-center"
                        />
                    </button>
                    <Popover
                        id={1}
                        open={openPopUpId1 === 1}
                        anchorEl={anchorElValue}
                        onClose={handlePopUpCloseValue}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        sx={{
                            marginTop: "1rem",
                            "& .MuiPaper-root": {
                                border: "1px solid #fff",
                                borderRadius: "1.1rem",
                                minWidth: "30rem",
                                boxShadow:
                                    "0px 0px 23px 0px rgba(0, 0, 0, 0.15)",
                            },
                        }}
                    >
                        <Typography
                            className="flex-column"
                            style={{
                                width: "100%",
                                maxHeight: "200px",
                                overflowY: "scroll",
                            }}
                        >
                            <div className="flex flex-col gap-[0px] py-[12px] px-[12px] text-[#30456D] ">
                                <label
                                    className="custom-select-option font-16-600"
                                    key="0"
                                >
                                    <input
                                        type="checkbox"
                                        className="custom-checkbox-input"
                                        checked={
                                            entity?.length ===
                                            entityList?.length
                                        }
                                        onChange={() => handleEntity(1)}
                                    />
                                    <span className="custom-checkbox"></span>
                                    Todas as Entidades
                                </label>
                                {entityList?.length > 0 &&
                                    entityList.map((item) => (
                                        <label
                                            className="custom-select-option font-16-400"
                                            key={item.id}
                                        >
                                            <input
                                                type="checkbox"
                                                className="custom-checkbox-input"
                                                checked={entity?.includes(
                                                    item.name
                                                )}
                                                onChange={() =>
                                                    handleEntity(
                                                        item.id,
                                                        item.name
                                                    )
                                                }
                                            />
                                            <span className="custom-checkbox"></span>
                                            {item.name}
                                        </label>
                                    ))}
                            </div>
                        </Typography>
                    </Popover>
                </div>
            ) :
            (
                <div className="flex flex-col gap-[5px] col-span-3">
                    <p className="font-14-700 text-[#697DA4] text-left">
                        Entidades
                    </p>
                    <div
                        className="bg-white w-full h-[35px] rounded-[100px] flex flex-row justify-between  self-center place-content-center px-[14px]"
                    >
                        <span className="font-16-500 text-[#95AFC9] self-center">
                            Todas
                        </span>
                    </div>
                </div>
            )}
            {
                <div className="flex flex-col gap-[5px] col-span-3">
                    <p className="font-14-700 text-[#697DA4] text-left">
                        Permissões de acesso
                    </p>
                    <button
                        className="bg-white w-full h-[35px] rounded-[100px] flex flex-row justify-between self-center place-content-center px-[14px]"
                        onClick={(e) => handlPopUpValueAcess(e, 2)}
                    >
                        <span className="font-16-500 text-[#29215B] self-center">
                            {access.some((item) => item.isChecked) ? (
                                access.find((item) => item.isChecked)?.name +
                                (access.filter((item) => item.isChecked)
                                    .length > 1
                                    ? "... +" +
                                      (access.filter((item) => item.isChecked)
                                          .length -
                                          1)
                                    : "")
                            ) : (
                                <span className="font-16-500 text-[#95AFC9] self-center">
                                    Selecionar...
                                </span>
                            )}
                        </span>
                        <KeyboardArrowDownIcon
                            style={{ fontSize: "18px" }}
                            className="self-center"
                        />
                    </button>
                    <Popover
                        id={2}
                        open={openPopUpId2 === 2}
                        anchorEl={anchorElValue2}
                        onClose={handlePopUpCloseValueAcess}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        sx={{
                            marginTop: "1rem",
                            "& .MuiPaper-root": {
                                border: "1px solid #fff",
                                borderRadius: "1.1rem",
                                minWidth: "40rem",
                                boxShadow:
                                    "0px 0px 23px 0px rgba(0, 0, 0, 0.15)",
                            },
                        }}
                    >
                        <Typography
                            className="flex-column"
                            style={{ width: "100%" }}
                        >
                            <div className="flex flex-col gap-[8px] p-[26px]">
                                <div className="flex flex-row justify-between text-[#95AFC9] font-14-400">
                                    <span>Acessos </span>
                                    <span>Editar / Ver</span>
                                </div>
                                <label
                                    className="custom-select-option font-16-600"
                                    key="0"
                                >
                                    <input
                                        type="checkbox"
                                        className="custom-checkbox-input"
                                        checked={isAllSelected}
                                        value={isAllSelected}
                                        onChange={() => handleSelectAll()}
                                    />
                                    <span className="custom-checkbox"></span>
                                    Todos
                                </label>
                                {access?.map((data, index) => (
                                    <div
                                        className="flex flex-row justify-between text-[#29215B]"
                                        key={index}
                                    >
                                        <label className="custom-select-option font-16-600">
                                            <input
                                                type="checkbox"
                                                className="custom-checkbox-input"
                                                checked={data.isChecked}
                                                value={data.isChecked}
                                                onChange={() =>
                                                    handleAccess(
                                                        data.alias,
                                                        data.isChecked
                                                    )
                                                }
                                            />
                                            <span className="custom-checkbox"></span>
                                            {data.name}
                                        </label>
                                        <div className="flex flex-row gap-0 bg-[#F2F5F8] rounded-[100px] w-[78px] h-[38px] justify-between">
                                            <button
                                                className={
                                                    data.isChecked === true
                                                        ? data.state === true
                                                            ? `p-[5px] w-[33px] h-[33px] ml-[3px] rounded-full bg-[#F9BC04] text-white self-center`
                                                            : `p-[2px] w-[36px] h-[36px] rounded-full`
                                                        : `p-[2px] w-[36px] h-[36px] rounded-full`
                                                }
                                                onClick={() =>
                                                    setStatus(data.alias, true)
                                                }
                                            >
                                                <EditIcon
                                                    style={
                                                        data.isChecked === true
                                                            ? data.state ===
                                                              true
                                                                ? {
                                                                      color: "#fff",
                                                                  }
                                                                : {
                                                                      color: "#95AFC9",
                                                                  }
                                                            : {
                                                                  color: "#95AFC9",
                                                              }
                                                    }
                                                />
                                            </button>
                                            <button
                                                className={
                                                    data.isChecked === true &&
                                                    data.state === false
                                                        ? `p-[5px] w-[33px] h-[33px] mr-[3px] rounded-full bg-[#F9BC04] text-white self-center`
                                                        : `p-[2px] w-[36px] h-[36px] rounded-full`
                                                }
                                                onClick={() =>
                                                    setStatus(data.alias, false)
                                                }
                                            >
                                                <VisibilityIcon
                                                    style={
                                                        data.isChecked ===
                                                            true &&
                                                        true &&
                                                        data.state === false
                                                            ? {
                                                                  color: "#fff",
                                                              }
                                                            : {
                                                                  color: "#95AFC9",
                                                              }
                                                    }
                                                />
                                            </button>
                                        </div>
                                    </div>
                                ))}

                                {/* <div className="flex flex-row justify-between text-[#29215B]">
                                    <label
                                        className="custom-select-option font-16-600"
                                        key="0"
                                    >
                                        <input
                                            type="checkbox"
                                            className="custom-checkbox-input"
                                            checked={access?.some(
                                                (item) =>
                                                    item.name ===
                                                    "Gestão Financeira"
                                            )}
                                            onChange={() =>
                                                handleAccess(
                                                    "Gestão Financeira"
                                                )
                                            }
                                        />
                                        <span className="custom-checkbox"></span>
                                        Gestão Financeira
                                    </label>
                                    <div className="flex flex-row gap-0 bg-[#F2F5F8] rounded-[100px] w-[78px] h-[38px] justify-between">
                                        <button
                                            className={
                                                access?.find(
                                                    (item) =>
                                                        item.name ===
                                                        "Gestão Financeira"
                                                )?.state === 1
                                                    ? `p-[5px] w-[33px] h-[33px] ml-[3px] rounded-full bg-[#F9BC04] text-white self-center`
                                                    : `p-[2px] w-[36px] h-[36px] rounded-full`
                                            }
                                            onClick={() =>
                                                setStatus(
                                                    "Gestão Financeira",
                                                    1
                                                )
                                            }
                                        >
                                            <EditIcon
                                                style={
                                                    access?.find(
                                                        (item) =>
                                                            item.name ===
                                                            "Gestão Financeira"
                                                    )?.state === 1
                                                        ? { color: "#fff" }
                                                        : { color: "#95AFC9" }
                                                }
                                            />
                                        </button>
                                        <button
                                            className={
                                                access?.find(
                                                    (item) =>
                                                        item.name ===
                                                        "Gestão Financeira"
                                                )?.state === 2
                                                    ? `p-[5px] w-[33px] h-[33px] mr-[3px] rounded-full bg-[#F9BC04] text-white self-center`
                                                    : `p-[2px] w-[36px] h-[36px] rounded-full`
                                            }
                                            onClick={() =>
                                                setStatus(
                                                    "Gestão Financeira",
                                                    2
                                                )
                                            }
                                        >
                                            <VisibilityIcon
                                                style={
                                                    access?.find(
                                                        (item) =>
                                                            item.name ===
                                                            "Gestão Financeira"
                                                    )?.state === 2
                                                        ? { color: "#fff" }
                                                        : { color: "#95AFC9" }
                                                }
                                            />
                                        </button>
                                    </div>
                                </div>

                                <div className="flex flex-row justify-between text-[#29215B]">
                                    <label
                                        className="custom-select-option font-16-600"
                                        key="0"
                                    >
                                        <input
                                            type="checkbox"
                                            className="custom-checkbox-input"
                                            checked={access?.some(
                                                (item) =>
                                                    item.name ===
                                                    "Gestão Clinica"
                                            )}
                                            onChange={() =>
                                                handleAccess("Gestão Clinica")
                                            }
                                        />
                                        <span className="custom-checkbox"></span>
                                        Gestão Clinica
                                    </label>
                                    <div className="flex flex-row gap-0 bg-[#F2F5F8] rounded-[100px] w-[78px] h-[38px] justify-between">
                                        <button
                                            className={
                                                access?.find(
                                                    (item) =>
                                                        item.name ===
                                                        "Gestão Clinica"
                                                )?.state === 1
                                                    ? `p-[5px] w-[33px] h-[33px] ml-[3px] rounded-full bg-[#F9BC04] text-white self-center`
                                                    : `p-[2px] w-[36px] h-[36px] rounded-full`
                                            }
                                            onClick={() =>
                                                setStatus("Gestão Clinica", 1)
                                            }
                                        >
                                            <EditIcon
                                                style={
                                                    access?.find(
                                                        (item) =>
                                                            item.name ===
                                                            "Gestão Clinica"
                                                    )?.state === 1
                                                        ? { color: "#fff" }
                                                        : { color: "#95AFC9" }
                                                }
                                            />
                                        </button>
                                        <button
                                            className={
                                                access?.find(
                                                    (item) =>
                                                        item.name ===
                                                        "Gestão Clinica"
                                                )?.state === 2
                                                    ? `p-[5px] w-[33px] h-[33px] mr-[3px] rounded-full bg-[#F9BC04] text-white self-center`
                                                    : `p-[2px] w-[36px] h-[36px] rounded-full`
                                            }
                                            onClick={() =>
                                                setStatus("Gestão Clinica", 2)
                                            }
                                        >
                                            <VisibilityIcon
                                                style={
                                                    access?.find(
                                                        (item) =>
                                                            item.name ===
                                                            "Gestão Clinica"
                                                    )?.state === 2
                                                        ? { color: "#fff" }
                                                        : { color: "#95AFC9" }
                                                }
                                            />
                                        </button>
                                    </div>
                                </div> */}
                            </div>
                        </Typography>
                    </Popover>
                </div>
                // (
                //     <div className="flex flex-col gap-[5px] col-span-3">
                //         <p className="font-14-700 text-[#697DA4] text-left">Permissões de acesso</p>
                //         <button className="bg-white w-full h-[35px] rounded-[100px] flex flex-row justify-between self-center place-content-center px-[14px]"  ><span className="font-16-500 text-[#29215B] self-center">Todas </span> </button>
                //         <Popover
                //             id={2}
                //             open={openPopUpId2 === 2}
                //             anchorEl={anchorElValue2}
                //             onClose={handlePopUpCloseValueAcess}
                //             anchorOrigin={{
                //                 vertical: 'bottom',
                //                 horizontal: 'right',
                //             }}
                //             transformOrigin={{
                //                 vertical: 'top',
                //                 horizontal: 'right',
                //             }}
                //             sx={{
                //                 marginTop: '1rem',
                //                 '& .MuiPaper-root': {
                //                     border: '1px solid #fff',
                //                     borderRadius: '1.1rem',
                //                     minWidth: '42rem',
                //                     boxShadow: '0px 0px 23px 0px rgba(0, 0, 0, 0.15)',
                //                 },
                //             }}
                //         >
                //             <Typography className="flex-column" style={{ width: '100%' }}>
                //                 <div className="flex flex-col gap-[8px] p-[26px]">
                //                     {/* <div className="flex flex-row gap-[10px] px-[16px] py-[8px] bg-[#29215B1A] text-[#29215B] font-13-500 rounded-[11px] items-center">
                //                         <InfoIcon />
                //                         <p>
                //                         Este membro terá acesso a tudo. <br></br>
                //                         Novas funcionalidades estão em desenvolvimento.
                //                         </p>
                //                     </div> */}
                //                     <div className="flex flex-row justify-between text-[#95AFC9] font-14-400">
                //                         <span>Acessos </span>
                //                         <span>Editar / Ver</span>
                //                     </div>
                //                     <label className="custom-select-option font-16-600" key="0">
                //                         <input
                //                             type="checkbox"
                //                             className="custom-checkbox-input1 "
                //                             checked={true}

                //                         />
                //                         <span className="custom-checkbox "></span>
                //                         Todos
                //                     </label>
                //                     <div className="flex flex-row justify-between text-[#29215B]">
                //                         <label className="custom-select-option font-16-600" key="0">
                //                             <input
                //                                 type="checkbox"
                //                                 className="custom-checkbox-input1"
                //                                 checked={true}

                //                             />
                //                             <span className="custom-checkbox"></span>
                //                             Registo de Consumos
                //                         </label>
                //                         <div className="flex flex-row gap-0 bg-[#F2F5F8] rounded-[100px] w-[78px] h-[38px] justify-between">
                //                             <button className={`p-[5px] w-[33px] h-[33px] ml-[3px] rounded-full bg-[#F9BC04] text-white self-center`} > <EditIcon style={{ color: '#fff' }} /> </button>
                //                             <button className={`p-[2px] w-[36px] h-[36px] rounded-full`} > <VisibilityIcon style={{ color: '#95AFC9' }} /> </button>
                //                         </div>
                //                     </div>

                //                     <div className="flex flex-row justify-between text-[#29215B]">
                //                         <label className="custom-select-option font-16-600" key="0">
                //                             <input
                //                                 type="checkbox"
                //                                 className="custom-checkbox-input1"
                //                                 checked={true}

                //                             />
                //                             <span className="custom-checkbox"></span>
                //                             Gestão Financeira
                //                         </label>
                //                         <div className="flex flex-row gap-0 bg-[#F2F5F8] rounded-[100px] w-[78px] h-[38px] justify-between">
                //                             <button className={`p-[5px] w-[33px] h-[33px] ml-[3px] rounded-full bg-[#F9BC04] text-white self-center`} > <EditIcon style={{ color: '#fff' }} /> </button>
                //                             <button className={`p-[2px] w-[36px] h-[36px] rounded-full`} > <VisibilityIcon style={{ color: '#95AFC9' }} /> </button>
                //                         </div>
                //                     </div>

                //                     <div className="flex flex-row justify-between text-[#29215B]">
                //                         <label className="custom-select-option font-16-600" key="0">
                //                             <input
                //                                 type="checkbox"
                //                                 className="custom-checkbox-input1"
                //                                 checked={true}
                //                             />
                //                             <span className="custom-checkbox"></span>
                //                             Gestão Clinica
                //                         </label>
                //                         <div className="flex flex-row gap-0 bg-[#F2F5F8] rounded-[100px] w-[78px] h-[38px] justify-between">
                //                             <button className={`p-[5px] w-[33px] h-[33px] ml-[3px] rounded-full bg-[#F9BC04] text-white self-center`} > <EditIcon style={{ color: '#fff' }} /> </button>
                //                             <button className={`p-[2px] w-[36px] h-[36px] rounded-full`} > <VisibilityIcon style={{ color: '#95AFC9' }} /> </button>
                //                         </div>
                //                     </div>

                //                 </div>
                //             </Typography>
                //         </Popover>
                //     </div>)
            }
            {item.status > 0 && (
                <button
                    className="text-[#697DA4] absolute top-[45px] right-[16px] w-[30px] h-[30px] rounded-full bg-[#F9BC04]"
                    onClick={() => onUpdate()}
                >
                    <CheckOutlinedIcon
                        style={{ fontSize: "20", color: "#fff" }}
                    />
                </button>
            )}
            {members.length > 1 ? (
                item.status === 0 ? (
                    <button
                        className="text-[#697DA4] absolute top-[16px] right-[16px]"
                        onClick={() => onClose()}
                    >
                        <DeleteIcon style={{ fontSize: "20" }} />
                    </button>
                ) : (
                    <button
                        className="text-[#697DA4] absolute top-[16px] right-[16px]"
                        onClick={() => onBack()}
                    >
                        <CloseIcon style={{ fontSize: "20" }} />
                    </button>
                )
            ) : (
                <button
                    className="text-[#697DA4] absolute top-[16px] right-[16px]"
                    onClick={() => onBack()}
                >
                    <CloseIcon style={{ fontSize: "20" }} />
                </button>
            )}
        </div>
    );
};

export default AddComponent;
